import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { FC } from 'react';

export type TLoaderProps = {
	size?: string;
};
export const Loader: FC<TLoaderProps> = ({ size }) => {
	return (
		<Box
			sx={
				{
					// display: 'flex',
					// border: '1px solid #e6e8ec',
					// justifyContent: 'center',
					// alignItems: 'center',
					// minHeight: '400px',
				}
			}
		>
			<CircularProgress size={size === 'mini' ? 20 : 40} />
		</Box>
	);
};
